import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

function getOrCreateAnonId() {
  let id = localStorage.getItem('retro_anon_id');
  if (!id) { id = crypto.randomUUID(); localStorage.setItem('retro_anon_id', id); }
  return id;
}

export default function JoinPage() {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [session, setSession] = useState(null);
  const [displayName, setDisplayName] = useState(user?.displayName || '');
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const pid = localStorage.getItem(`retro_participant_${sessionId}`);
    if (pid) { navigate(`/session/${sessionId}`, { replace: true }); return; }

    api.sessions.get(sessionId)
      .then(data => {
        setSession(data);
        if (user) {
          const myP = (data.participants || []).find(p => p.jira_id === user.jiraId && p.is_active);
          if (myP) { localStorage.setItem(`retro_participant_${sessionId}`, myP.id); navigate(`/session/${sessionId}`, { replace: true }); }
        }
      })
      .catch(() => setError('Session not found or no longer active.'))
      .finally(() => setLoading(false));
  }, [sessionId]);

  const handleJoin = async () => {
    if (!displayName.trim()) return;
    setJoining(true);
    try {
      const { participant } = await api.sessions.join(sessionId, { display_name: displayName.trim(), anonymous_id: getOrCreateAnonId() });
      localStorage.setItem(`retro_participant_${sessionId}`, participant.id);
      navigate(`/session/${sessionId}`);
    } catch (e) { setError(e.message); setJoining(false); }
  };

  if (loading) return <div className="page flex items-center justify-center" style={{ minHeight: '60vh' }}><p className="text-muted">Loading...</p></div>;

  if (error && !session) return (
    <div className="page flex items-center justify-center" style={{ minHeight: '60vh' }}>
      <div className="card" style={{ maxWidth: 400, textAlign: 'center', padding: '48px 32px' }}>
        <div style={{ fontSize: '3rem', marginBottom: 16 }}>😕</div>
        <h2 style={{ marginBottom: 8 }}>Session Not Found</h2>
        <p className="text-muted mb-6">{error}</p>
        <button className="btn btn-primary" onClick={() => navigate('/')}>Go Home</button>
      </div>
    </div>
  );

  return (
    <div className="page flex items-center justify-center" style={{ minHeight: '60vh' }}>
      <div className="card" style={{ maxWidth: 440, width: '100%', padding: '40px 32px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: '3rem', marginBottom: 12 }}>🔄</div>
          <h2 style={{ marginBottom: 4 }}>Join Retro</h2>
          {session && (
            <>
              <p className="font-bold" style={{ marginBottom: 4 }}>{session.name}</p>
              <p className="text-sm text-muted">{session.teams?.name} · {session.facilitator_name}</p>
              <div className="flex items-center justify-center gap-3 mt-3">
                <span className="badge badge-green">Active</span>
                <span className="badge badge-muted">{session.participants?.length || 0} joined</span>
              </div>
            </>
          )}
        </div>

        <div className="input-group">
          <label className="input-label">Your Name (or stay anonymous)</label>
          <input className="input" value={displayName} onChange={e => setDisplayName(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleJoin()} placeholder="Enter a name or nickname..." autoFocus />
          <p className="text-xs text-muted mt-1">You can use your real name or any name you like.</p>
        </div>

        {error && <div className="toast toast-error mb-4">{error}</div>}

        <button className="btn btn-primary w-full btn-lg" onClick={handleJoin} disabled={joining || !displayName.trim()}>
          {joining ? 'Joining...' : '🔄 Join Retro'}
        </button>
        <p className="text-xs text-muted mt-4" style={{ textAlign: 'center' }}>No account needed.</p>
      </div>
    </div>
  );
}
